import React from "react"

const Credits = () => {
  return (
    <div className="credits">
      <div className="content">
        <h2>Credits</h2>
        <ul className="list-credits">
          <li>
            <div className="hold-item">
              <h3>Show Production</h3>
              <ul className="inner-list">
                <li>Do Great Projects</li>
                <li>Cory O’Donnell, Producer</li>
                <li>Kristin Whalley, Producer</li>
                <li>Bex Schwartz, Writer</li>
                <li>Nathaniel Pincus-Roth, Writer</li>
                <li>Sara Benincasa, Writer</li>
                <li>Ellie McCoy, Coordinator</li>
              </ul>
            </div>
            <div className="hold-item">
              <h3>Website Design</h3>
              <ul className="inner-list">
                <li>
                  <span className="subtext">Queue Development</span>
                </li>
              </ul>
            </div>
            <div className="hold-item">
              <h3>Lankenua’s Story</h3>
              <ul className="inner-list">
                <li>
                  <span className="subtext">
                    Written and directed by Katie Cappiello
                  </span>
                </li>
              </ul>
            </div>
          </li>
          <li>
            <div className="hold-item">
              <h3>Post Production</h3>
              <ul className="inner-list">
                <li>PostScript Creative</li>
                <li>Jessica Rothert, Post Production Producer</li>
                <li>Peter Saroufim, Lead Editor</li>

                <li>Stephen Interrante, Lead GFX</li>
                <li>Brad Allen Wilde, Editor</li>
                <li>Brendan Merrill, Editor</li>
                <li>Ethan Landry, Assistant Editor</li>
                <li>Sasha Vagos, Assistant Editor</li>
                <li>Muhammad Khan, Junior GFX</li>
              </ul>
            </div>
            <div className="hold-item">
              <h3>Press</h3>
              <ul className="inner-list">
                <li>Slate PR</li>
              </ul>
            </div>
          </li>
        </ul>
      </div>
    </div>
  )
}

export default Credits
